import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApisAdminOperatorsOperatorsEditResponseType } from "~/domains";

type RequestDataType = {
  id: string;
};

const request = async ({
  id,
}: RequestDataType): Promise<ApisAdminOperatorsOperatorsEditResponseType> => {
  const response =
    await new ApiClient().get<ApisAdminOperatorsOperatorsEditResponseType>(
      `/api/admin_operators/operators/${id}/edit`,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  id: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisAdminOperatorsOperatorsEdit = ({
  id,
  config = {},
}: PropsType): UseQueryResult<ApisAdminOperatorsOperatorsEditResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisAdminOperatorsOperatorsEdit", id],
    queryFn: () => request({ id }),
  });
};
